import React, { PropsWithChildren } from 'react';
import { Header } from '@/features/header/pages/Header';
import { MenuPage } from '@/features/menu/pages/MenuPage';
import { GlobalFilterApp } from '@/features/global-filter/GlobalFilterApp';
const userData = {
  userId: '12345',
  username: 'john doe',
  initials: 'JD',
  avatar: '',
};

export const Layout: React.FC<PropsWithChildren> = ({ children }) => {
  const availableItems = [
    { id: '1', name: 'João Silva', type: 'profile' },
    { id: '2', name: 'Maria Oliveira', type: 'profile' },
    { id: '3', name: 'Tech Group', type: 'group' },
    { id: '4', name: 'Marketing Theme', type: 'theme' },
    { id: '5', name: 'Ana Maria Souza', type: 'profile' },
    { id: '6', name: 'Ana Maria', type: 'profile' },
    { id: '7', name: 'Tech Innovations', type: 'group' },
  ];

  const filterLabels = [
    '<b>Intervalo de datas</b>: 13/11/2025 00:00 a 12/12/2025 23:59',
    '<b>Grupos</b>: Grupo do @, -Capivara, grupo 3, outro grupo, mais um grupo',
    '<b>Temas</b>: Tema do #, -Capivara',
    '<b>Tags</b>: Tag do #, -Capivara, aaaaa, tagtag, capivarias',
    '<b>Canais</b>: Canal do @, -Capivara',
    '<b>Interesses</b>: Interesse do @, -Capivara, interesse 3, interesse 4',
    '<b>Contendo texto</b>: \'texto a ser buscado\'',
    '<b>Sentimento</b>: Positivo, Negativo, Neutro',
    '<b>Curtidas/Gostei</b>: >100, <50',
    '<b>Compartilhamentos</b>: >50, <20',
    '<b>Views</b>: >1000, <500',
    '<b>Comentários</b>: >200, <10',
    '<b>Usuários</b>: @usuario1, @usuario2',
    '<b>Gênero</b>: Masculino, Feminino, Outro',
    '<b>Seguidores/Inscritos</b>: >1000, <500',
    '<b>Classificado por</b>: @classificador1, @classificador2',
    '<b>Publicações anotadas</b>: >100, <20',
    '<b>Checado</b>: Sim, Não',
    '<b>Língua</b>: Português, Inglês, Espanhol',
  ];

  return (
    <div>
      <Header userData={userData} availableItems={availableItems} filterLabels={filterLabels} />
      <GlobalFilterApp />
      <div>
        <MenuPage />
        <main>
          {children}
        </main>
      </div>
    </div>
  );
};
